import { gql } from "@apollo/client";

export const GET_EMPLOYEE_OPS_REPORT = gql`
  query GetEmployeeOpsReport($filter: EmployeeOpsFilter) {
    getEmployeeOpsReport(filter: $filter) {
      status
      message
      data {
        thresholds {
          onTimeMinutes
          veryLateMinutes
          burstTravelSeconds
          burstServiceMinutes
          farMetres
        }
        # JSON objects (one field each - the API caps a query at 150 fields);
        # keys are listed on EmployeeOpsReport in the backend schema.
        summary
        employees
        featureUsage
        delayBuckets {
          key
          label
          count
        }
        byHour {
          hour
          starts
          late
          avgDelay
          medianDelay
        }
        byDay {
          day
          starts
          late
          medianDelay
          holds
        }
        holdActors {
          actorType
          holds
        }
        holds {
          orderId
          bookingId
          bookingDay
          timeSlot
          status
          holdStatus
          employeeId
          employeeName
          holdStartedAt
          holdStartedByType
          holdStartedByName
          respondedAt
          minutesFromSlot
        }
        lateStarts {
          orderId
          bookingId
          bookingDay
          timeSlot
          employeeId
          employeeName
          slotAt
          reachedAt
          startedAt
          startDelay
          reachDelay
          runningLateSent
          firstLateNoticeAt
        }
        farFromCustomer {
          orderId
          bookingId
          bookingDay
          timeSlot
          employeeId
          employeeName
          reachDistance
          startDistance
          accuracy
          mocked
        }
      }
    }
  }
`;
